import type { EditorKeys, EditorKeyEvent } from './use-editor-keys.types'
export function useEditorKeys({ onEnter, onEscape, blurOnEnter }: EditorKeys) {
  return (event: EditorKeyEvent) => {
    if (event.key === 'Escape') onEscape?.()
    if (event.key !== 'Enter' || event.shiftKey) return
    event.preventDefault()
    if (blurOnEnter && event.currentTarget) event.currentTarget.blur()
    else onEnter()
  }
}

export function isFocusWithin(event: { currentTarget: unknown; relatedTarget?: unknown }): boolean {
  return event.currentTarget instanceof Node && event.relatedTarget instanceof Node && event.currentTarget.contains(event.relatedTarget)
}
